module.exports = __webpack_public_path__ + "static/media/report_bg.9c8898b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/report_bg.svg
// module id = 339
// module chunks = 0